module.exports = __webpack_public_path__ + "static/media/icon _timer.3f974327.svg";